import React from "react";
import { getAppStyles } from "../../theme/app-theme";
import "./styles.scss";

interface FooterProps {
    isDarkMode?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isDarkMode = false }) => {
    const styles = getAppStyles(isDarkMode);

    return (
        <footer
            style={styles.footer}
            className={`footer-main-content ${isDarkMode ? "footer-main-content--dark" : ""}`}
        >
            <p style={{ marginLeft: "40px" }}>
                2025 © Hospital São Marcelino Champagnat, Inc.{" "}
            </p>
            <p style={{ marginRight: "40px" }}>
                <a href="#">Política de Privacidade</a>
            </p>
        </footer>
    );
};

export default Footer;
